var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.447266 0.447754 0 1 0H5C5.45898 0 5.85889 0.3125 5.97021 0.757812L6.78076 4H23.1428C23.4487 4 23.738 4.13965 23.9275 4.37988C24.1172 4.62012 24.1865 4.93359 24.1157 5.23145L21.9729 14.2314C21.936 14.3867 21.8643 14.5264 21.7673 14.6416C21.7131 14.7061 21.6511 14.7637 21.583 14.8125C21.4175 14.9307 21.2153 15 21 15H8C7.53125 15 7.12549 14.6748 7.02393 14.2168L5.02661 5.22949L4.21924 2H1C0.447754 2 0 1.55273 0 1ZM7.24658 6L8.80225 13H20.2102L21.8767 6H7.24658Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5C10 18.3281 9.32837 19 8.5 19C7.67163 19 7 18.3281 7 17.5C7 17.1084 7.15015 16.752 7.39624 16.4844C7.67041 16.1865 8.06348 16 8.5 16C9.32837 16 10 16.6719 10 17.5Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 19C21.3284 19 22 18.3281 22 17.5C22 16.6719 21.3284 16 20.5 16C19.6716 16 19 16.6719 19 17.5C19 18.3281 19.6716 19 20.5 19Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.8f70096e071aef7d48c29f7c540e9e65.svg";
export { ForwardRef as ReactComponent };